import { Directive, inject, input } from '@angular/core';
import { PlausibleService } from '@agilox/common';

@Directive({
	selector: '[directivePlausible]',
	host: {
		'(click)': 'onClick()',
	},
})
export class PlausibleDirective {
	private plausibleService = inject(PlausibleService);

	eventName = input<string>('');
	eventLabel = input<any>(null);

	onClick() {
		this.plausibleService.eventEmitter(this.eventName(), this.eventLabel());
	}
}
